/**
 * Component to display the invite customer button on a subscription
 * experience (in the flow, or on manage subscription).
 * 
 * To determine whether this is a re-invite or invite scenario, we
 * need to see if an invitation has already been sent.  To do this,
 * we use a dedicated query to get the last invitation information,
 * which looks at users associated with an account, and magic links
 * that have been sent for an account.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Button, Tooltip } from '@mui/material';
import AbEnvironment from '../auth/AbEnvironment';
import ServerError from '../ui/ServerError';

import withStyles from '@mui/styles/withStyles';

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
    }
});

const abEnvironment = new AbEnvironment();
const InviteCustomerButtonQuery = graphql`
    query InviteCustomerButtonQuery($accountId: UUID!) {
        getdefaultcustomerinviteuser(accountid: $accountId) {
          userid
          lastname
          firstname
          email
          previousinvitecount
        }
      }
    `;

class InviteCustomerButton extends Component {
    /*
    invite = (bcUser) => {
        let bu = {
            userid:              bcUser.userid,
            lastname:            bcUser.lastname,
            firstname:           bcUser.firstname,
            email:               bcUser.email,
            previousinvitecount: bcUser.previousinvitecount,
            accountId:           this.props.accountId,
            customerAppId:       this.props.customerAppId
        }
        this.props.invite(bcUser);
    }
    */
  invite (bcUser) {
        let bu = {
            userid:              bcUser.userid,
            lastname:            bcUser.lastname,
            firstname:           bcUser.firstname,
            email:               bcUser.email,
            previousinvitecount: bcUser.previousinvitecount,
            accountId:           this.props.accountId,
            customerAppId:       this.props.customerAppId
        }
        this.props.invite(bu);
    }

    reInvite (bcUser) {
        let bu = {
            userid:              bcUser.userid,
            lastname:            bcUser.lastname,
            firstname:           bcUser.firstname,
            email:               bcUser.email,
            previousinvitecount: bcUser.previousinvitecount,
            accountId:           this.props.accountId,
            customerAppId:       this.props.customerAppId
        }
        this.props.reInvite(bu);
    }

    render() {
        const { logError } = this.props.auth;
        const acctId = this.props.accountId;

        let buttonType = "contained";
        if (this.props.buttonType) {
          buttonType = "outlined";
        }

        let who = "Your customer";
        let itt = "Invite your customer to AppBind so that they can add a funding source to pay for subscriptions you manage for them";

        let disabled = false;
        if (this.props.disabled === true) {
          disabled = true;
        }

        let reInviteLabel = this.props.reInviteLabelOverride;
        if (!reInviteLabel) {
          reInviteLabel = 'Reinvite ' + who;
        }

        return (
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={InviteCustomerButtonQuery}
            variables={{accountId: acctId}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                if (this.props.whoInvite) {
                  who = this.props.whoInvite;
                }
                if (this.props.whoTooltip) {
                  itt = this.props.whoTooltip;
                }
       
                let reInviteTooltip = this.props.reInviteTooltipOverride;
                if (!reInviteTooltip) {
                  reInviteTooltip = itt;
                }

                let bcUser = props.getdefaultcustomerinviteuser;
                let prevInviteCount = parseInt(bcUser.previousinvitecount, 10);
                if (!disabled) {
                  
                  if (prevInviteCount > 0) {
                    return (
                      <Tooltip title={reInviteTooltip}>
                        <Button color="primary" variant="outlined" onClick={() => {this.reInvite(bcUser)}} disabled={disabled}>
                          {reInviteLabel}
                        </Button>
                      </Tooltip>
                    );
                  } else {
                    return (
                      <Tooltip title={itt}>
                        <Button color="primary" variant={buttonType} onClick={() => {this.invite(bcUser)}} disabled={disabled}>
                          Invite {who}
                        </Button>
                      </Tooltip>
                    );
                  }
                } else {
                  //react does not like tooltip on a disabled button.
                  if (prevInviteCount > 0) {
                    return (
                        <Button color="primary" variant="outlined" onClick={() => {this.reInvite(bcUser)}} disabled={disabled}>
                          {reInviteLabel}
                        </Button>
                    );
                  } else {
                    return (
                        <Button color="primary" variant={buttonType} onClick={() => {this.invite(bcUser)}} disabled={disabled}>
                          Invite {who}
                        </Button>
                    );
                  }

                }
              }
              return (
                <Button color="primary" variant={buttonType}>
                  Invite {who}
                </Button>
              );
            }}
          />
        );
    }
}

export default withStyles(styleSheet)(InviteCustomerButton); 